/* HJ Graveyard collection hero: rain, lightning strike and the stacked-rewards tracker. Used by snippets/GraveyardCollectionSnippet.liquid. */
(function () {
'use strict';
if (window.__hjgh) return;
window.__hjgh = 1;
var M = Math, R = M.random, RM = matchMedia('(prefers-reduced-motion: reduce)');
var BANDS = [.22, .45, .72, 1.01], LEAD = 170, END = 1850;
function boltI(p) { return p < LEAD ? .85 : p < 240 ? 1 : p < 310 ? .35 : p < 380 ? .95 : p < 1500 ? .95 * M.exp((380 - p) / 300) : 0; }
function hitAt(p) { var f = (p - 700) / 1100; return p < 150 ? 0 : p < 240 ? (p - 150) / 90 : p < 700 ? 1 : p < 1800 ? 1 - f * f * (3 - 2 * f) : 0; }
function cr(a, b, c, d, t) {
var t2 = t * t, t3 = t2 * t;
function f(i) { return .5 * (2 * b[i] + (c[i] - a[i]) * t + (2 * a[i] - 5 * b[i] + 4 * c[i] - d[i]) * t2 + (3 * b[i] - a[i] - 3 * c[i] + d[i]) * t3); }
return [f(0), f(1)];
}
function resample(p, n) {
var L = [0], o = [], i, j = 1, s, f;
for (i = 1; i < p.length; i++) L.push(L[i - 1] + M.hypot(p[i][0] - p[i - 1][0], p[i][1] - p[i - 1][1]));
for (i = 0; i <= n; i++) {
s = L[L.length - 1] * i / n;
while (j < L.length - 1 && L[j] < s) j++;
f = (s - L[j - 1]) / ((L[j] - L[j - 1]) || 1);
o.push([p[j - 1][0] + (p[j][0] - p[j - 1][0]) * f, p[j - 1][1] + (p[j][1] - p[j - 1][1]) * f]);
}
return o;
}
function init(root) {
if (root.hjgh) return;
var hero = root.querySelector('.hjgh__hero'), cv = root.querySelector('.hjgh__fx'), x = cv && cv.getContext('2d');
var pill = root.querySelector('.hjgh__live'), deal = root.querySelector('.hjgh__deal'), ds = root.dataset;
var rain = ds.rain == null ? .28 : M.max(0, M.min(1, +ds.rain || 0)), bolt = ds.bolt !== 'off';
var every = M.max(3, +ds.boltEvery || 6) * 1000;
var W = 0, H = 0, D = 1, kr = 1, kb = 1, u = 1, desk = false, drops = [], spl = [], n = 0, dirty = true;
var raf = 0, wait = 0, last = 0, clock = 0, next = 1400, at = -1e9, g = null, vis = false;
function emit(name) { root.dispatchEvent(new CustomEvent('hjgh:event', { bubbles: true, detail: { name: name } })); }
function drop(d, init) {
var z = .22 + M.pow(R(), 1.6) * .78, g0 = desk ? .76 : .74, g1 = desk ? .9 : .92;
d.z = z; d.len = (7 + z * 20) * kr; d.sp = (430 + z * 640) * u;
d.x = R() * (W + H * .5) - H * .5; d.g = H * (g0 + R() * (g1 - g0));
d.y = init ? R() * d.g : -20 - R() * 140;
return d;
}
function size() {
var w = cv.clientWidth, h = cv.clientHeight, i;
if (!w || !h) return false;
dirty = false; W = w; H = h; D = M.min(2, devicePixelRatio || 1);
cv.width = M.round(w * D); cv.height = M.round(h * D);
kr = M.max(1, M.min(1.6, w / 402)); kb = M.max(1, M.min(1.7, w / 402)); u = M.max(.8, M.min(1.4, h / 700));
desk = root.clientWidth >= 700;
n = M.round(M.max(60, M.min(520, 170 * w * h / 281400)) * rain);
drops = []; spl = []; g = null;
for (i = 0; i < n; i++) drops.push(drop({}, 1));
return true;
}
function pt(el, fx, fy, cb, sx, sy) { var r = el.getBoundingClientRect(); return [(r.left - cb.left + r.width * fx) / sx, (r.top - cb.top + r.height * fy) / sy]; }
function geom() {
if (!pill || !deal) return null;
var cb = cv.getBoundingClientRect(), sx = cb.width / W || 1, sy = cb.height / H || 1;
var A = pt(pill, .12, 1, cb, sx, sy), B = pt(deal, .2, -.02, cb, sx, sy), i, j;
var via = desk ? [[.24, .3], [.25, .5], [.21, .64]].map(function (v) { return [M.max(W * .02, W / 2 - v[0] * H), v[1] * H]; })
: [[.2, .278], [.12, .5], [.11, .674]].map(function (v) { return [v[0] * W, v[1] * H]; });
var P = [A].concat(via, [B]), dense = [];
for (i = 0; i < P.length - 1; i++) for (j = 0; j < 16; j++) dense.push(cr(P[i - 1] || P[i], P[i], P[i + 1], P[i + 2] || P[i + 1], j / 16));
dense.push(B);
var guide = resample(dense, 240), len = 0;
for (i = 1; i < guide.length; i++) len += M.hypot(guide[i][0] - guide[i - 1][0], guide[i][1] - guide[i - 1][1]);
var segs = M.max(10, M.min(48, M.round(len / (15 * kb)))), sm = resample(guide, segs), amp = 8 * kb, path = [sm[0]], fine, cum = [0];
for (i = 1; i < segs; i++) {
var t = i / segs, a = sm[i - 1], b = sm[i + 1], tx = b[0] - a[0], ty = b[1] - a[1], tl = M.hypot(tx, ty) || 1;
var o = (R() - .5) * 2 * amp * M.min(1, t * 6) * (t > .84 ? M.max(0, (1 - t) / .16) : 1);
path.push([sm[i][0] - ty / tl * o, sm[i][1] + tx / tl * o]);
}
path.push(sm[segs]);
fine = [path[0]];
for (i = 1; i < path.length; i++) {
var p = path[i - 1], q = path[i], dx = q[0] - p[0], dy = q[1] - p[1], dl = M.hypot(dx, dy) || 1, oo = i / path.length > .86 ? 0 : (R() - .5) * amp * .7;
fine.push([(p[0] + q[0]) / 2 - dy / dl * oo, (p[1] + q[1]) / 2 + dx / dl * oo], q);
}
for (i = 1; i < fine.length; i++) cum.push(cum[i - 1] + M.hypot(fine[i][0] - fine[i - 1][0], fine[i][1] - fine[i - 1][1]));
var e0 = sm[segs - 2], ex = B[0] - e0[0], ey = B[1] - e0[1], el = M.hypot(ex, ey) || 1, br = [];
for (j = 0; j < 2; j++) {
var ix = M.floor(fine.length * (.16 + R() * .36)), at0 = fine[ix], nx = fine[M.min(fine.length - 1, ix + 2)];
var bx = nx[0] - at0[0], by = nx[1] - at0[1], bl = M.hypot(bx, by) || 1, ang = (R() < .5 ? -1 : 1) * (.45 + R() * .35);
var ux = (bx * M.cos(ang) - by * M.sin(ang)) / bl;
if ((W / 2 - at0[0]) * ux > 0) { ang = -ang; ux = (bx * M.cos(ang) - by * M.sin(ang)) / bl; }
var uy = (bx * M.sin(ang) + by * M.cos(ang)) / bl, l2 = (26 + R() * 34) * kb, f = [at0];
for (var m = 1; m <= 6; m++) { var ff = m / 6, jj = (R() - .5) * 8 * kb * (1 - ff * .5); f.push([at0[0] + ux * l2 * ff - uy * jj, at0[1] + uy * l2 * ff + ux * jj]); }
br.push(f);
}
return { path: fine, cum: cum, len: cum[cum.length - 1], dir: [ex / el, ey / el], B: B, mid: fine[M.floor(fine.length * .45)], br: br };
}
function line(p, w) { if (p.length < 2) return; x.lineWidth = w; x.beginPath(); x.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) x.lineTo(p[i][0], p[i][1]); x.stroke(); }
function forks(w, a) { x.globalAlpha = a; for (var i = 0; i < g.br.length; i++) line(g.br[i], w); x.globalAlpha = 1; }
function drawBolt(ph) {
var I = boltI(ph), q = ph < LEAD ? 1 - M.pow(1 - ph / LEAD, 2) : 1, k = kb, up = g.len * q, pts = [], i, s;
if (I < .01) return;
for (i = 0; i < g.path.length; i++) {
if (g.cum[i] <= up) { pts.push(g.path[i]); continue; }
var a = g.path[i - 1], b = g.path[i], f = (up - g.cum[i - 1]) / ((g.cum[i] - g.cum[i - 1]) || 1);
pts.push([a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f]);
break;
}
var hit = q >= 1;
x.save();
if (hit) { s = x.createRadialGradient(g.mid[0], g.mid[1], 0, g.mid[0], g.mid[1], M.max(W, H) * .6); s.addColorStop(0, 'rgba(170,200,255,' + .17 * I + ')'); s.addColorStop(1, 'rgba(170,200,255,0)'); x.fillStyle = s; x.fillRect(0, 0, W, H); }
x.lineJoin = x.lineCap = 'round';
x.strokeStyle = 'rgba(4,8,22,' + .3 * I + ')'; x.shadowColor = 'rgba(4,8,22,' + .35 * I + ')'; x.shadowBlur = 10 * k * D;
line(pts, 6 * k); if (hit) forks(4 * k, 1);
x.globalCompositeOperation = 'lighter';
x.shadowColor = 'rgba(100,155,255,' + I + ')'; x.shadowBlur = 18 * k * D;
x.strokeStyle = 'rgba(120,170,255,' + .4 * I + ')'; line(pts, 5.5 * k); if (hit) forks(3 * k, .6);
x.shadowBlur = 6 * k * D; x.strokeStyle = 'rgba(205,225,255,' + .88 * I + ')'; line(pts, 2.2 * k); if (hit) forks(1.2 * k, .6);
x.shadowBlur = 0; x.strokeStyle = 'rgba(255,255,255,' + I + ')'; line(pts, 1.1 * k);
if (!hit) { var tip = pts[pts.length - 1]; x.shadowColor = '#96c3ff'; x.shadowBlur = 14 * k * D; x.fillStyle = '#fff'; x.beginPath(); x.arc(tip[0], tip[1], 3 * k, 0, 6.283); x.fill(); }
else {
var d = g.dir, B = g.B, L = 18 * k, Wd = 10 * k, nx = -d[1] * Wd, ny = d[0] * Wd;
var T = [B[0] + d[0] * 3 * k, B[1] + d[1] * 3 * k], C = [B[0] - d[0] * L, B[1] - d[1] * L], Nc = [B[0] - d[0] * L * .5, B[1] - d[1] * L * .5];
var poly = function () { x.beginPath(); x.moveTo(T[0], T[1]); x.lineTo(C[0] + nx, C[1] + ny); x.lineTo(Nc[0], Nc[1]); x.lineTo(C[0] - nx, C[1] - ny); x.closePath(); };
s = x.createRadialGradient(B[0], B[1], 0, B[0], B[1], 40 * k);
s.addColorStop(0, 'rgba(255,255,255,' + .45 * I + ')'); s.addColorStop(.4, 'rgba(140,180,255,' + .22 * I + ')'); s.addColorStop(1, 'rgba(140,180,255,0)');
x.fillStyle = s; x.fillRect(B[0] - 40 * k, B[1] - 40 * k, 80 * k, 80 * k);
x.shadowColor = 'rgba(100,155,255,' + I + ')'; x.shadowBlur = 16 * k * D; x.fillStyle = 'rgba(160,200,255,' + .7 * I + ')'; poly(); x.fill();
x.shadowBlur = 4 * k * D; x.fillStyle = 'rgba(255,255,255,' + I + ')'; poly(); x.fill();
x.lineJoin = 'miter'; x.strokeStyle = 'rgba(205,225,255,' + I + ')'; x.lineWidth = 1.2 * k; poly(); x.stroke();
}
x.restore();
}
function rainStep(dt) {
var wind = .36 + .08 * M.sin(clock / 2600) + .04 * M.sin(clock / 830), b, i, d, s, p, r;
x.lineCap = 'round';
for (b = 0; b < 3; b++) {
x.beginPath();
for (i = 0; i < n; i++) { d = drops[i]; if (d.z >= BANDS[b] && d.z < BANDS[b + 1]) { x.moveTo(d.x, d.y); x.lineTo(d.x - wind * d.len, d.y - d.len); } }
x.strokeStyle = 'rgba(12,16,26,' + (.1 + b * .06) + ')'; x.lineWidth = 1.6 + b * .6; x.stroke();
x.strokeStyle = 'rgba(226,233,246,' + (.26 + b * .17) + ')'; x.lineWidth = .85 + b * .45; x.stroke();
}
x.beginPath(); x.strokeStyle = 'rgba(226,232,244,.45)'; x.lineWidth = .7;
for (i = spl.length - 1; i >= 0; i--) {
s = spl[i]; s.t += dt; p = s.t / .26;
if (p >= 1) { spl.splice(i, 1); continue; }
r = (1.5 + p * 6) * kr;
x.moveTo(s.x - r * .4, s.y - r * .15); x.lineTo(s.x - r, s.y - r * .7 * (1 - p));
x.moveTo(s.x + r * .4, s.y - r * .15); x.lineTo(s.x + r, s.y - r * .7 * (1 - p));
}
x.stroke();
for (i = 0; i < n; i++) {
d = drops[i]; d.y += d.sp * dt; d.x += d.sp * wind * dt;
if (d.y > d.g) { if (d.z > .7 && spl.length < 40) spl.push({ x: d.x, y: d.g, t: 0 }); drop(d); }
}
}
function on() { return x && vis && !document.hidden && !RM.matches && (rain > 0 || bolt); }
function frame(t) {
raf = 0;
if (dirty && !size()) return;
var dt = last ? M.min(.05, (t - last) / 1000) : .016, ph;
last = t; clock += dt * 1000;
if (bolt && clock >= next) { at = clock; next = clock + every; g = geom(); }
x.setTransform(D, 0, 0, D, 0, 0); x.clearRect(0, 0, W, H);
if (n) rainStep(dt);
ph = clock - at;
if (g && ph < END) { drawBolt(ph); deal.style.setProperty('--hit', hitAt(ph).toFixed(3)); }
else if (g) { g = null; deal.style.setProperty('--hit', 0); }
loop();
}
function loop() {
if (!on()) return stop();
if (n || g) { if (!raf) raf = requestAnimationFrame(frame); }
else if (!wait) wait = setTimeout(function () { wait = 0; clock = M.max(clock, next); last = 0; if (on() && !raf) raf = requestAnimationFrame(frame); }, M.max(0, next - clock));
}
function stop() {
cancelAnimationFrame(raf); clearTimeout(wait); raf = wait = 0; last = 0;
if (RM.matches && x) { x.clearRect(0, 0, cv.width, cv.height); if (deal) deal.style.setProperty('--hit', 0); g = null; }
}
function run() { if (on()) { if (dirty) size(); loop(); } else stop(); }
var tiers = [].slice.call(root.querySelectorAll('.hjgh__tier')), fill = root.querySelector('.hjgh__fill');
var foot = root.querySelector('.hjgh__foot'), card = root.querySelector('.hjgh__card'), tick = 0, seq = 0, cardVis = false;
function show(t) {
var cnt = tiers.length, s = M.min(t, 5), nx = tiers[s], f = s <= 0 ? 0 : s >= cnt ? 100 : (s - .5) / cnt * 100;
if (!cnt) return;
tiers.forEach(function (li, i) { li.classList.toggle('is-hit', i < s); li.classList.toggle('is-next', i === s); li.classList.toggle('is-ding', i === s - 1 && t === s); });
fill.style.width = f >= 100 ? 'calc(100% - var(--in) * 2)' : 'max(0px, calc(' + f.toFixed(2) + '% - var(--in)))';
fill.style.setProperty('--glow', 'rgba(' + tiers[M.max(0, s - 1)].style.getPropertyValue('--c') + ',.5)');
foot.lastChild.textContent = !nx ? 'ALL ' + cnt + ' UNLOCKED · AUTO-ADDED AT CHECKOUT' : nx.dataset.amt === '1' ? 'ANY ORDER UNLOCKS HALLOWEEN FREEBIES' : 'SPEND $' + nx.dataset.amt + ' · ' + nx.dataset.foot;
foot.firstChild.textContent = nx ? '▸' : '✓';
foot.classList.toggle('is-done', !nx);
foot.classList.remove('is-in'); void foot.offsetWidth; foot.classList.add('is-in');
}
function seqOn(v) {
clearInterval(seq); seq = 0;
if (v && !RM.matches) seq = setInterval(function () { if (!document.hidden) show(tick = (tick + 1) % 8); }, 1000);
}
if (card) show(RM.matches ? 5 : 0);
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.target === hero) { vis = e.isIntersecting; run(); } else seqOn(cardVis = e.isIntersecting); });
}, { rootMargin: '150px 0px' });
var ro = new ResizeObserver(function () { dirty = true; g = null; run(); });
function motion() { run(); if (card) { seqOn(cardVis); if (RM.matches) show(5); } }
if (cv) { io.observe(hero); ro.observe(cv); }
if (card) io.observe(card);
document.addEventListener('visibilitychange', run);
if (RM.addEventListener) RM.addEventListener('change', motion);
var sheet = root.querySelector('.hjgh__sheet'), opener = null;
function close() { if (sheet && sheet.open) sheet.close(); document.documentElement.classList.remove('hjgh-lock'); }
function go(e) {
var el = null;
emit('hj_graveyard_shop_click');
try { el = ds.products && document.querySelector(ds.products); } catch (er) {}
if (!el) return;
e.preventDefault();
scrollTo({ top: M.max(0, el.getBoundingClientRect().top + pageYOffset - (+ds.offset || 0)), behavior: RM.matches ? 'auto' : 'smooth' });
}
root.addEventListener('click', function (e) {
var t = e.target, o = t.closest('[data-open]'), c = t.closest('[data-close]');
if (o && sheet) { opener = o; sheet.showModal(); document.documentElement.classList.add('hjgh-lock'); emit('hj_graveyard_rewards_open'); }
else if (c) { close(); if (c.href) go(e); }
else if (t.closest('.hjgh__down')) go(e);
else if (t === sheet) close();
});
if (sheet) sheet.addEventListener('close', function () { document.documentElement.classList.remove('hjgh-lock'); if (opener) opener.focus({ preventScroll: true }); });
root.hjgh = {
strike: function () { if (!x || !W) return; at = clock; next = clock + every; g = geom(); clearTimeout(wait); wait = 0; raf = raf || requestAnimationFrame(frame); },
destroy: function () { vis = false; stop(); seqOn(false); io.disconnect(); ro.disconnect(); document.removeEventListener('visibilitychange', run); if (RM.removeEventListener) RM.removeEventListener('change', motion); root.hjgh = null; }
};
}
function boot(scope) { [].forEach.call((scope || document).querySelectorAll('.hjgh'), init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('.hjgh'); if (r && r.hjgh) r.hjgh.destroy(); });
})();
